import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import logo from "../assets/logo.png"; // আপনার লোগো ফাইলের নাম দিন

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isCVPage = location.pathname === "/cv";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // মেনু আইটেমের লিংক
  const menuItems = [
    { name: "Home", link: "/#home" },
    { name: "About", link: "/#aboutus" },
    { name: "Services", link: "/#services" },
    { name: "Portfolio", link: "/#portfolio" },
    { name: "Our Team", link: "/#ourteam" },
    { name: "Contact", link: "/#contactus" },
  ];

  // CV পেজে স্ক্রল হ্যান্ডলিং
  const handleNavClick = (e, link) => {
    e.preventDefault();
    
    const hash = link.split("#")[1];
    
    if (isCVPage) {
      window.location.href = `/${hash ? `#${hash}` : ''}`;
    } else {
      let element = null;
      
      if (hash === "contactus") {
        element = document.getElementById("contactus");
        if (!element) element = document.getElementById("contact");
      } else {
        element = document.getElementById(hash);
      }
      
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.href = `/#${hash}`;
      }
    }
    setIsOpen(false);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.location.href = "/";
    setIsOpen(false);
  };

  const handleSignInClick = () => {
    console.log("Sign In clicked");
    setIsOpen(false);
  };

  const textColor = "#1a1f36";
  const bgColor = scrolled ? "rgba(255, 255, 255, 0.95)" : "transparent";
  const backdropBlur = scrolled ? "blur(10px)" : "none";
  const boxShadow = scrolled ? "0 4px 20px rgba(0,0,0,0.1)" : "none";

  return (
    <>
      {/* Google Fonts Import */}
      <link 
        href="https://fonts.googleapis.com/css2?family=Fredoka+One&family=Luckiest+Guy&display=swap" 
        rel="stylesheet"
      />
      
      <nav style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: scrolled ? "10px 20px" : "20px 40px",
        background: bgColor,
        backdropFilter: backdropBlur,
        boxShadow: boxShadow,
        transition: "all 0.3s ease",
      }}>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: "1400px",
          margin: "0 auto",
        }}>
          {/* লোগো + Pyrux Text */}
          <a 
            href="/"
            onClick={handleLogoClick}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            <img 
              src={logo} 
              alt="YourAgency Logo"
              style={{
                height: scrolled ? "40px" : "50px",
                width: "auto",
                transition: "all 0.3s ease",
                objectFit: "contain",
              }}
            />
            {/* Pyrux Text - Cartoon Style Bold Font */}
            {/* Pyrux Text - Cartoon Style Bold Font */}
            {/* Pyrux Text - Cartoon Style Bold Font */}
            <span
              style={{
                fontSize: scrolled ? "16px" : "22px",
                fontWeight: "600",
                fontFamily: "'Fredoka One', 'Luckiest Guy', cursive",
                letterSpacing: "1.5px",
                marginTop: "2px",
                transition: "all 0.3s ease",
                textTransform: "uppercase",

                // ✅ Soft Ash Black (not too dark)
                color: "#2f2f2f",

                // very subtle softness
                textShadow: "0 1px 1px rgba(0,0,0,0.05)"
              }}
            >
              PYRUX
            </span>
          </a>

          {/* ডেস্কটপ মেনু আইটেম */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "30px",
          }}>
            {/* মেনু আইটেম - ডেস্কটপ */}
            <ul style={{
              display: "flex",
              gap: "25px",
              alignItems: "center",
              listStyle: "none",
              margin: 0,
              padding: 0,
            }}>
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.link}
                    onClick={(e) => handleNavClick(e, item.link)}
                    style={{
                      color: textColor,
                      textDecoration: "none",
                      fontSize: "clamp(0.9rem, 1.2vw, 1rem)",
                      fontWeight: "500",
                      transition: "color 0.3s ease",
                      cursor: "pointer",
                      opacity: isCVPage ? 0.7 : 1,
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = "#FF4444"}
                    onMouseLeave={(e) => e.currentTarget.style.color = textColor}
                  >
                    {item.name}
                  </a>
                </li>
              ))}

              {/* Sign In Button */}
              <li
                onClick={handleSignInClick}
                style={{
                  cursor: "pointer",
                  padding: "0.35rem 0.8rem",
                  borderRadius: "25px",
                  backgroundColor: "rgba(0,0,0,0.05)",
                  color: "#1a1f36",
                  fontWeight: 500,
                  border: "1px solid rgba(0,0,0,0.2)",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3rem",
                  transition: "all 0.3s ease",
                  fontSize: "clamp(0.8rem, 1.2vw, 1rem)",
                  listStyle: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.1)";
                  e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.05)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <FiUser /> Sign in
              </li>
            </ul>

            {/* মোবাইল মেনু টগল বাটন */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              style={{
                display: "none",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "24px",
                color: textColor,
              }}
              className="mobile-menu-toggle"
            >
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {/* মোবাইল মেনু ড্রপডাউন */}
        {isOpen && (
          <ul style={{
            position: "absolute",
            top: scrolled ? "60px" : "80px",
            left: 0,
            right: 0,
            background: "#fff",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            listStyle: "none",
            margin: 0,
          }}>
            {menuItems.map((item, index) => (
              <li key={index}>
                <a
                  href={item.link}
                  onClick={(e) => handleNavClick(e, item.link)}
                  style={{
                    color: textColor,
                    textDecoration: "none",
                    fontSize: "18px",
                    padding: "10px",
                    display: "block",
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                  }}
                >
                  {item.name}
                </a>
              </li>
            ))}
            {/* মোবাইলে সাইন ইন বাটন */}
            <li
              onClick={handleSignInClick}
              style={{
                cursor: "pointer",
                padding: "12px",
                borderRadius: "25px",
                backgroundColor: "rgba(0,0,0,0.05)",
                color: "#1a1f36",
                fontWeight: 500,
                border: "1px solid rgba(0,0,0,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
                transition: "all 0.3s ease",
                fontSize: "16px",
                marginTop: "10px",
                listStyle: "none",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.1)";
                e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.05)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <FiUser /> Sign in
            </li>
          </ul>
        )}

        {/* রেসপন্সিভ স্টাইল */}
        <style>
          {`
            @media (max-width: 768px) {
              .mobile-menu-toggle {
                display: block !important;
              }
              nav > div > div > ul:first-of-type {
                display: none !important;
              }
            }
          `}
        </style>
      </nav>
    </>
  );
};

export default Menu;